import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Instagram, MapPin, Phone, Clock3 } from 'lucide-react';
import AnimatedSection from './AnimatedSection';
import { fadeInUp, staggerContainer } from '../utils/animations';
import './SiteFooter.css';

function SiteFooter() {
  return (
    <footer className="site-footer">
      <AnimatedSection variants={staggerContainer} className="main-shell site-footer__grid">
        <motion.div variants={fadeInUp}>
          <h3>Balkan Barber</h3>
          <p>332 Barrow St, Jersey City, NJ 07302</p>
          <p>Old-school style with the new-school touch. Downtown Jersey City since day one.</p>
        </motion.div>

        <motion.div variants={fadeInUp}>
          <h4>Quick Links</h4>
          <div className="site-footer__links">
            <Link to="/about">About</Link>
            <Link to="/booking">Book Appointment</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms and Conditions</Link>
          </div>
        </motion.div>

        <motion.div variants={fadeInUp}>
          <h4>Contact</h4>
          <p><Phone size={14} /> <a href="tel:+12014332870">(201) 433-2870</a></p>
          <p><MapPin size={14} /> Downtown Jersey City</p>
          <p><Clock3 size={14} /> Mon-Fri: 10a-7p · Sat-Sun: 9a-4p</p>
          <p><Instagram size={14} /> <a href="https://www.instagram.com/balkanbarber/?hl=en" target="_blank" rel="noreferrer">@balkanbarber</a></p>
        </motion.div>
      </AnimatedSection>

      <div className="site-footer__base">
        <div className="main-shell">
          <span>&copy; {new Date().getFullYear()} Balkan Barber. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
